<template>
    <div class="voz-ecosystem-and-company-content" id="identidade-verbal-voz-empresa" data-search-anchor>
        <div class="voz-logo-container" :style="{ backgroundImage: `url(${vozLogoImageSrc})` }"></div>

        <div class="voz-line-svg-container">
            <svg width="588" height="14" viewBox="0 0 588 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0.5 14V0.5H587.5V14" stroke="black" />
            </svg>
        </div>

        <div class="voz-colums-wrapper">

            <div class="voz-ecosystem-container">
                <p class="voz-ecosystem-paragraph-title">{{ vozEcosystemParagraphTitle }}</p>

                <div class="voz-ecosystem-container-wrapper">
                  <div class="icon-ecosystem-wrapper ">
                    <IconCheck />
                    <p class="voz-ecosystem-paragraph">{{ vozEcosystemParagraph1 }}</p>
                  </div>
                  <div class="icon-ecosystem-wrapper ">
                    <IconCheck />
                    <p class="voz-ecosystem-paragraph">{{ vozEcosystemParagraph2 }}</p>
                </div>
                <div class="icon-ecosystem-wrapper ">
                    <IconCheck />
                    <p class="voz-ecosystem-paragraph">{{ vozEcosystemParagraph3 }}</p>
                </div>
                </div>                
            </div>

            <div class="voz-company-container">              
                <p class="voz-company-paragraph-tilte">{{ vozCompanyParagraphTitle }}</p>

                <div class="voz-company-container-wrapper">
                  
                <div class="icon-company-wrapper">
                    <IconCheck />
                    <p class="voz-company-paragraph">{{ vozCompanyParagraph1 }}</p>
                </div>
                <div class="icon-company-wrapper">
                    <IconCheck />
                    <p class="voz-company-paragraph">{{ vozCompanyParagraph2 }}</p>
                </div>
                <div class="icon-company-wrapper">
                    <IconCheck />
                    <p class="voz-company-paragraph">{{ vozCompanyParagraph3 }}</p>
                </div>
                <div class="icon-company-wrapper">
                    <IconCheck />
                    <p class="voz-company-paragraph">{{ vozCompanyParagraph4 }}</p>
                </div>
                <div class="icon-company-wrapper">
                    <IconCheck />
                    <p class="voz-company-paragraph">{{ vozCompanyParagraph5 }}</p>
                </div>
                <div class="icon-company-wrapper">
                    <IconCheck />
                    <p class="voz-company-paragraph">{{ vozCompanyParagraph6 }}</p>
                </div>                  
                </div>
            </div>
        </div>
    </div>

</template>

<script lang="ts">
import IconCheck from '@/assets/icons/IconCheck.vue'
import { PageStoreContract } from '@/data/store/page.store.contract'
import VozPageMixin from '@/mixins/voz-page-mixin'
import { VozPageStore } from '@/store/verbal-identity-page/voz-store'
import { Component, Mixins } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'

@Component({components: { IconCheck }})
export default class VozEcosystemAndCompanyBrandSection extends Mixins(VozPageMixin) {
  vozPageStore: PageStoreContract = getModule(VozPageStore, this.$store)

  get vozLogoImageSrc(): string {
    return this.getElementMedia(2, 0)
  }

  get vozEcosystemParagraphTitle(): string {
    return this.getElementText(2, 0)
  }

  get vozEcosystemParagraph1(): string {
    return this.getElementText(2, 1)
  }

  get vozEcosystemParagraph2(): string {
    return this.getElementText(2, 2)
  }

  get vozEcosystemParagraph3(): string {
    return this.getElementText(2, 3)
  }

  get vozCompanyParagraphTitle(): string {
    return this.getElementText(2, 4)
  }

  get vozCompanyParagraph1(): string {
    return this.getElementText(2, 5)
  }

  get vozCompanyParagraph2(): string {
    return this.getElementText(2, 6)
  }

  get vozCompanyParagraph3(): string {
    return this.getElementText(2, 7)
  }

  get vozCompanyParagraph4(): string {
    return this.getElementText(2, 8)
  }

  get vozCompanyParagraph5(): string {
    return this.getElementText(2, 9)
  }

  get vozCompanyParagraph6(): string {
    return this.getElementText(2, 10)
  }

  async getVozPage(): Promise<void> {
    await this.vozPageStore.getDataPage()
  }

  async mounted(): Promise<void> {
    if (!this.vozPageStore.isLoading) {
      await this.getVozPage()
    }
  }
}
</script>

<style lang="scss">
.voz-ecosystem-and-company-content {
  display: grid;
  justify-content: center;
  margin-top: 96px;  
  max-width: 1032px;
}

.voz-logo-container {
  width: 206px;
  height: 59px;
  opacity: 1;
  margin: 0 auto;
  margin-bottom: 20.5px;
}

.voz-line-svg-container {
  max-width: 1032px;
  margin: 0 auto;
  display: flex;
  justify-content: center; 
}

.voz-colums-wrapper {
  position: relative;
  display: grid;
  grid-template-columns: repeat(2, 495px);
  gap: 38px;
}

.voz-ecosystem-container,
.voz-company-container {
  width: 495px;
  height: 486px;
  background-color: #f0f0f0;
  border-radius: 16px;
  margin-top: 24px;
}

.voz-ecosystem-paragraph,
.voz-company-paragraph {
  font-weight: 600;
  font-size: 16px;  
  padding-left: 8px;
  margin: 0;
}

.voz-ecosystem-paragraph-title,
.voz-company-paragraph-tilte {
  font-weight: 600;
  font-size: 24px;  
  line-height: 28px;
  margin:44px 0 30px 43px;   
  width: 318px; 
}

.voz-ecosystem-container-wrapper,
.voz-company-container-wrapper {
  margin:30px 0 30px 33px;
}

.icon-ecosystem-wrapper,
.icon-company-wrapper {
  display: flex;
  align-items: center;
  padding-bottom: 24px;
}


</style>
 